import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';
import { Upload } from '@styled-icons/foundation/Upload';
import { QuestionCircleFill } from '@styled-icons/bootstrap/QuestionCircleFill';

export const Required = styled.div`
  position: relative;
  font-weight: normal; 
  font-size: 13px;
  text-align: right;
  padding-right: 40px
`;

export const ActionButton = styled.button`
background-color: white;
border: 1px solid #20907f;
color: #20907f;
font-weight: bold;
width: 110px;
max-width: 110px;
border-radius: 25px;
padding: 8px;
margin: 10px;
margin-top: 30px;
display: flex;
align-items: center;
justify-content: center;
&:hover {
  cursor: pointer;
  background-color: #20907f;
  color: white;
}
&:disabled {
  background-color: #ccc;
  border: 1px solid #ccc;
  color: white;
  cursor: default;
}
`;

export const FileButton = styled.button`
  background-color: white;
  border: 1px solid #20907f;
  color: #20907f;
  font-weight: bold;
  width: 150px;
  max-width: 150px;
  border-radius: 25px;
  padding: 8px;
  margin: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    background-color: #20907f;
    color: white;
  }
  &:disabled {
    background-color: #ccc;
    border: 1px solid #ccc;
    color: white;
    cursor: default;
  }
  &:selected {
    border:none;
  }
`;

export const Span = styled.span`
display: inline-flex;
`;
export const FileUploadIcon = styled(Upload)`
padding: 0 0.4em 0.8em 0;
`;

export const InputGroup = styled.div`
  display: inline-flex;
  width: 100%;
`;

export const OR = styled.div`
  margin: auto;
  margin-left: 20px;
  margin-right: 20px;
`;

export const QMARK = styled(QuestionCircleFill)`
  margin: auto;
  margin-left: 6px;
  margin-right: 6px;
`;

export const TextInput = styled.input`
padding: 12px 9px 9px 10px;
vertical-align: bottom;
font-size: 14px;
line-height: 14px;
letter-spacing: 0.5px;
color: ${({ theme }) => theme.input.focus || 'unset' };
text-align: left;
margin: auto;
box-sizing: border-box;
height: 35px;
width: 100%;
border: 1px solid ${({ theme }) => theme.input.border || 'unset'};
border-radius: 3px;
background-color: ${({ theme }) => theme.input.secondary || 'unset'};
&:focus {
    border-color: ${({ theme }) => theme.input.focus || 'unset'};
    outline: none;
}
&::placeholder {
    color: ${({ theme }) => theme.text.hover || 'unset'};
}
&:disabled {
  color: #b2b2b2;
}
`;

export const Page = styled.div`
  font-family: 'Graphik', helvetica;
  font-size: 16px;
  background-color: #f2f2f2;
  padding-top: 50px;
  padding-bottom: 20px;
  color: #5a5b5e;
  overflow-y: scroll;
  margin-bottom: 20px;
`;

export const Card = styled.div`
  background: white;
  border-radius: 5px;
  border: 1px solid #cccccc;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
  margin: 20px 0 20px 0;
  padding-bottom: 20px;
  &:after {
    z-index: -1;
    -webkit-box-shadow: 0px 0px 8px 2px #000000;
       -moz-box-shadow: 0px 0px 8px 2px #000000;
            box-shadow: 0px 0px 8px 2px #000000;
  }
`;

export const CardBody = styled.div`
  padding: 20px;
`;


export const CardTitle = styled.div`
  color: #003D50;
  font-family: Helvetica, "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: bold;
  padding: 30px 10px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
`;

export const Container = styled.div`
  margin: 0px 20px;
`;

export const FieldGroup = styled.div`
  display: flex;
`;

export const FieldGroupInfo = styled.div`
  flex: 0 0 274px;
  margin-right: 20px;
`;

export const FieldGroupHeader = styled.div`
  font-size: 18px;
  line-height: 25px;
  font-weight: bold;
  margin-bottom: 10px;
`;

export const FieldGroupBody = styled.div`
  flex: 1 1 auto;
  margin-right: 25px;
  max-width: 700px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;

export const BigText = styled.p`
  font-size: 16px;
  line-height: 22px;
  margin: 0;
`;

export const Label = styled.label`
  display: block;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 14px;
  text-transform: uppercase;
  margin: 15px 0px 5px 0px;
  color: #999999;

  &:first-child {
    margin-top: 0;
  }
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 18px;
  margin: 0;
  margin-bottom: 10px;
`;

export const SubText = styled.p`
  font-size: 12px;
  line-height: 17px;
  margin: 0;
  margin-top: 5px;
  margin-bottom: 26px;
`;

export const HLine = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
  border-top: 1px solid #cccccc;
`;

export const FileInput = styled.input.attrs(props => ({
    type: 'file',
    size: props.size || '1em',
}))`
  border: 1px solid ${({ theme }) => theme.input.border || 'unset'};
  width: 40%;
  margin: ${props => props.size || 'unset'};
  padding: ${props => props.size || 'unset'};
  margin-left: 0;
  margin-right: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;
